import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatScrollToBottomAffordanceUtilityClass(slot) {
  return generateUtilityClass('MuiChatScrollToBottomAffordance', slot);
}
export const chatScrollToBottomAffordanceClasses = generateUtilityClasses('MuiChatScrollToBottomAffordance', ['root']);
const slots = {
  root: ['root']
};
export const useChatScrollToBottomAffordanceUtilityClasses = classes => composeClasses(slots, getChatScrollToBottomAffordanceUtilityClass, classes);